import { useContext } from "react";
import { Button } from "../tailwind/button";
import { CustomerContext } from "../../providers";
import { Heading } from "../tailwind/heading";
import { Text } from "../tailwind/text";

export const AddWhatsAppPaymentMethod = () => {
  const { customer } = useContext(CustomerContext);

  return (
    <div className="text-center flex flex-col justify-center items-center h-[70vh]">
      <Text>Go to your Meta Business Manager settings.</Text>
      <Text>If needed, add a payment method for your portfolio.</Text>
      <Text>
        Then apply this payment method to your newly created WhatsApp Account.
      </Text>
      <br />
      <Button
        color="secondaryButton"
        onClick={() =>
          window.open(
            "https://business.facebook.com/billing_hub/payment_methods",
            "_blank"
          )
        }
      >
        Business Manager settings
      </Button>
    </div>
  );
};
